import { render, staticRenderFns } from "./wxEnterpriseStaff.vue?vue&type=template&id=0cfa6582&scoped=true"
import script from "./wxEnterpriseStaff.vue?vue&type=script&lang=js"
export * from "./wxEnterpriseStaff.vue?vue&type=script&lang=js"
import style0 from "./wxEnterpriseStaff.vue?vue&type=style&index=0&id=0cfa6582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa6582",
  null
  
)

export default component.exports